import { FileText, LineChart, MessageSquare, Mic, Sparkles, Target } from "lucide-react";

const SCORES = [["Structure (STAR)", 88], ["Clarity", 92], ["Confidence", 76]];
const TOOLS = [[FileText, "Cover letter"], [Target, "Salary coach"], [LineChart, "LinkedIn rewrite"], [Sparkles, "Daily plan"]];

const Bubble = ({ me, delay, children }) => (
  <div className={`lp-rise flex ${me ? "justify-end" : ""}`} style={{ animationDelay: `${delay}ms` }}>
    <div className={`max-w-[88%] rounded-2xl px-3 py-2 text-[12px] leading-snug ${me ? "rounded-br-sm bg-[#D4AF37] text-[#09090B]" : "rounded-bl-sm border border-[#27272A] bg-[#18181B] text-zinc-200"}`}>{children}</div>
  </div>
);

const Chat = () => (
  <div className="rounded-xl border border-[#D4AF37]/15 bg-[#09090B]/60 p-3" data-testid="aip-chat">
    <div className="mb-3 flex items-center justify-between">
      <span className="flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.2em] text-[#D4AF37]"><Mic className="h-3 w-3" />Mock interview</span>
      <span className="flex items-center gap-1.5 font-mono text-[10px] text-zinc-500"><span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-500" />04:12</span>
    </div>
    <div className="space-y-2">
      <Bubble delay={300}>Tell me about a time you turned around a project that was behind schedule.</Bubble>
      <Bubble me delay={550}>Our launch slipped 3 weeks. I re-scoped with the team and shipped 2 days early…</Bubble>
      <div className="lp-rise flex items-center gap-1 pl-1" style={{ animationDelay: "800ms" }}>
        {[0, 1, 2].map((i) => <span key={i} className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#D4AF37]/70" style={{ animationDelay: `${i * 150}ms` }} />)}
        <span className="ml-1.5 text-[10px] text-zinc-500">Coach is reviewing your answer</span>
      </div>
    </div>
  </div>
);

const Feedback = () => (
  <div className="rounded-xl border border-[#D4AF37]/30 bg-gradient-to-br from-[#33290D] to-[#141108] p-3" data-testid="aip-feedback">
    <div className="mb-2.5 flex items-center justify-between">
      <span className="text-[9px] font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">Answer feedback</span>
      <span className="font-mono text-lg font-bold text-[#F3C649]">A-</span>
    </div>
    <div className="space-y-2">
      {SCORES.map(([l, v], i) => (
        <div key={l}>
          <div className="mb-1 flex justify-between text-[10px]"><span className="text-zinc-400">{l}</span><span className="font-mono text-zinc-200">{v}</span></div>
          <div className="h-1 overflow-hidden rounded-full bg-[#27272A]"><div className="lp-fill h-full rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F3C649]" style={{ width: `${v}%`, animationDelay: `${900 + i * 150}ms` }} /></div>
        </div>
      ))}
    </div>
    <p className="mt-2.5 text-[10px] leading-snug text-zinc-400"><span className="text-[#F3C649]">Tip:</span> Quantify the result. Say how many users the on-time launch reached.</p>
  </div>
);

export const StudioPreview = () => (
  <div className="lp-float relative mt-6" style={{ animationDelay: "-5s" }} data-testid="login-studio-preview">
    <div className="overflow-hidden rounded-2xl border border-[#D4AF37]/25 bg-[#121214]/90 p-3 shadow-[0_20px_50px_rgba(0,0,0,0.6)]">
      <div className="mb-3 flex items-center justify-between px-1">
        <span className="flex items-center gap-2 font-display text-sm text-zinc-100"><MessageSquare className="h-4 w-4 shrink-0 text-[#D4AF37]" />Coaching & Mock Interviews</span>
        <span className="shrink-0 rounded-full border border-[#D4AF37]/40 bg-[#33290D] px-2 py-0.5 text-[10px] text-[#F3C649]">Tuned to your resume</span>
      </div>
      <div className="grid gap-2.5 sm:grid-cols-[1.25fr_1fr]">
        <Chat />
        <Feedback />
      </div>
      <div className="mt-2.5 grid grid-cols-2 gap-2 sm:grid-cols-4">
        {TOOLS.map(([Icon, l], i) => (
          <div key={l} className="lp-rise flex items-center gap-2 rounded-lg border border-[#27272A] bg-[#18181B] px-2.5 py-2 text-[11px] text-zinc-300 transition-colors hover:border-[#D4AF37]/40" style={{ animationDelay: `${1000 + i * 100}ms` }} data-testid={`aip-tool-${i}`}>
            <Icon className="h-3.5 w-3.5 shrink-0 text-[#D4AF37]" /><span className="truncate">{l}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);
